import React from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

// Slider settings for a single logo slideshow
const settings = {
  dots: true, // Disable dots
  infinite: true, // Infinite loop
  speed: 500, // Transition speed
  slidesToShow: 1, // Show only one logo at a time
  slidesToScroll: 1, // Scroll one logo at a time
  autoplay: true, // Enable autoplay
  autoplaySpeed: 3000, // Change logo every 2 seconds
};

function Providers() {
  return (
    <>
      <div style={{ marginTop: "3rem", width: "100%", height: "10px" }} className="providers"></div>

      <div className="container about">
        {/* Logo slider section */}
        <div className="company-logos my-5">
        <h2 className="main-title text-center">OUR CLIENTS</h2>
          <Slider {...settings}>
            {/* Add your logos here, one will be displayed at a time */}
            <div>
              <img src={process.env.PUBLIC_URL + "/img/logo.png"} alt="Company Logo 1" className="img-flud" />
            </div>
            <div>
              <img src={process.env.PUBLIC_URL + "/img/logo.png"} alt="Company Logo 2" className="img-flud" />
            </div>
            <div>
              <img src={process.env.PUBLIC_URL + "/img/logo.png"} alt="Company Logo 3" className="img-flud" />
            </div>
            {/* Add more logos if needed */}
          </Slider>
        </div>
      </div>
      <div className="providers"></div>
    </>
  );
}

export default Providers;
